
import { Course } from '../types';

export const miam_mediation: Course = {
  id: "miam_mediation",
  title: "MIAM & Mediation",
  description: "The mandatory first step. Navigate the 2024 mediation rules successfully.",
  icon: "🤝",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/miam_mediation/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the validity period for a MIAM certificate?",
        "o": [
            "2 months",
            "3 months",
            "4 months",
            "6 months"
        ],
        "a": 2
    },
    {
        "q": "According to the 2024 rules, what is the court primarily looking for during a MIAM?",
        "o": [
            "Mere attendance to check a box",
            "A formal declaration of intent to mediate",
            "Genuine effort to engage in mediation",
            "A signed agreement to avoid court proceedings"
        ],
        "a": 2
    },
    {
        "q": "What severe consequence can result from refusing mediation without a valid, court-approved reason?",
        "o": [
            "Immediate imprisonment",
            "Payment of the other side's legal fees",
            "A permanent ban from future mediation",
            "A mandatory public apology"
        ],
        "a": 1
    },
    {
        "q": "Which of the following is NOT one of the four specific exemptions to bypass a MIAM?",
        "o": [
            "Domestic Abuse",
            "Financial Hardship",
            "Urgency (immediate risk of child removal)",
            "Distance (significant geographic barriers)"
        ],
        "a": 1
    },
    {
        "q": "What is the nature of a Memorandum of Understanding (MOU) reached during mediation?",
        "o": [
            "It is a legally binding final court order.",
            "It is a non-binding summary of agreements.",
            "It automatically transforms into a Consent Order after 7 days.",
            "It requires judicial review before being considered valid."
        ],
        "a": 1
    }
]
};
